import React, { Component } from 'react';
import { translate } from 'react-i18next';
import {withRouter} from 'react-router-dom';
import { connect } from 'react-redux';
import queryString from 'query-string';

import UserService from '../../services/UserService.js';
import {initNavbarState} from 'actions/navbar.js';
import Utils from 'utils/Utils.js';
import Keys from 'keys/keys.js';

import ChoosePassword from './ChoosePassword.js';
import AuthUtils from 'utils/AuthUtils.js';

class ChoosePasswordContainer extends Component {

    constructor(props){
		super(props);
        var urlParams = queryString.parse(this.props.location.search);
        var idParam=urlParams.id;
        var token=urlParams.token;
        var userName=urlParams.username;
        var error=urlParams.error;


       var formAction = Keys.AUTH_API_URL + idParam + '/request_password_reset'		

		this.state = {password:'', 
					  passwordConfirm:'', 
                      passwordError:'', 
                      passwordConfirmError:'',
                      error:error,
                      formAction:formAction,
                      token:token,
                      userName:userName};    


		this.onPasswordChange = this.onPasswordChange.bind(this);
		this.onPasswordConfirmChange = this.onPasswordConfirmChange.bind(this);
		this.onSubmit = this.onSubmit.bind(this);
		this.isValid = this.isValid.bind(this);
    }

    componentWillMount() {
        this.props.dispatch(initNavbarState({enable:true, title:this.props.t('Choose Password'), backButtonEnable:false}));
    }

	onPasswordChange(event) {
		this.setState({password: event.target.value}, this.isValid);
	}

	onPasswordConfirmChange(event) {
		this.setState({passwordConfirm: event.target.value}, this.isValid);
	}

	onSubmit(event) {
        if(!this.isValid(true)) {
            console.log('preventDefault');
		    event.preventDefault();
        }
	}
	
	isValid(submit) {
		var valid = true;

		this.setState({passwordError:'', passwordConfirmError:''});

		if(submit && (this.state.password).length === 0){
			this.setState({passwordError:this.props.t('Please choose your password')});
            valid = false;
		}

		if(submit && (this.state.password).length < AuthUtils.minPasswordLength){
			this.setState({passwordError:this.props.t('Password must be at least {{length}} characters', {length: AuthUtils.minPasswordLength})});
            valid = false;
		}

		if(submit && (this.state.passwordConfirm).length === 0){
			this.setState({passwordConfirmError:this.props.t('Please confirm your password')});
            valid = false;
		}

		if((this.state.password.length>0 && this.state.passwordConfirm.length>0) && this.state.password!=this.state.passwordConfirm){
			this.setState({passwordConfirmError:this.props.t('This field should be identical to the password field')});
            valid = false;
		}

		return valid;	
	}


    render() {
      return (
            <ChoosePassword 
                    userName={this.state.userName}
                    token={this.state.token}
                    formAction={this.state.formAction}
                    password={this.state.password}
                    passwordConfirm={this.state.passwordConfirm}
                    onSubmit={this.onSubmit}
                    onPasswordChange={this.onPasswordChange}
                    onPasswordConfirmChange={this.onPasswordConfirmChange}
                    passwordError={this.state.passwordError}
                    passwordConfirmError={this.state.passwordConfirmError}
                    error={this.state.error} />
      );
  }
}

export default withRouter(connect()(translate('authentication')(ChoosePasswordContainer)));



// WEBPACK FOOTER //
// ./src/modules/authentication/ChoosePasswordContainer.js